import { DialogObject } from '@/components/dialog/dialog.types';

export const getDocSubmissionDeleteObject = ({ store, action, toggleVisibility }: any): DialogObject => {
  return {
    title: 'settings.docSubmission.delete.title',
    description: '',
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'settings.docSubmission.delete.delete',
        variant: 'danger',
        onClick: () => action?.(),
      },
      {
        label: 'settings.docSubmission.delete.cancel',
        onClick: () => {
          toggleVisibility?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
